import type { SidebarSchema } from "./sidebarSchema.ts";

/**
 * Map a canonical entity page path (e.g. `/contacts/:id`, `/communications/:id`,
 * `/calendar/event/:id`) to the right-sidebar content that should open instead of
 * a full-page navigation. Returns null for paths with no sidebar representation
 * (navigate normally).
 *
 * This is the single source of truth for the sidebar interception boundary
 * (`SidebarNavBoundary`). Query and hash suffixes are stripped before matching;
 * a query-only URL write has no path segment and maps to null.
 */
export const sidebarContentForPath = (path: string): SidebarSchema | null => {
  const [, segment, id] = path.split(/[?#]/)[0].split("/");
  if (!id) return null;
  switch (segment) {
    case "contacts":
      return { type: "contactList", contactId: id };
    case "communications":
      return { type: "communication", id };
    // No calendar path has a sidebar form: `/calendar/event/:id` presents as a
    // canvas card where a canvas is mounted and loads its own page otherwise,
    // and a `/calendar?…` focus link moves a mounted calendar. Both fall through.
    default:
      return null;
  }
};
